import type { HTMLProps } from "react";

import * as styles from "./DropdownDivider.styles";

interface Props extends HTMLProps<HTMLHRElement> {
  /**
   * Optionally remove the top margin of the divider
   * Used when the item above it is NOT a DropdownItem/DropdownLink
   *
   */
  hasTopMargin?: boolean;
}

/**
 * @deprecated Use `DropdownMenu.Group` with the `showSeparator` prop from `@fullscript/aviary-web` instead. DS5 `DropdownMenu` has no `Separator` member.
 */
const DropdownDivider = ({ hasTopMargin = true, ...rest }: Props) => {
  const dividerStyles = [styles.dropdownDivider, hasTopMargin && styles.marginedTop];

  return <hr css={dividerStyles} {...rest} />;
};

export { DropdownDivider };
